import React from "react";

import Logger from "../../foundation/Logger";


interface ErrorBoundaryProps {
    sectionName?: string;

    children: React.ReactNode | React.ReactNode[];
}

interface ErrorBoundaryState {
    hasError?: boolean;
    errorMessage?: string;
}

export default class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    static getDerivedStateFromError(error: any): Partial<ErrorBoundaryState> {
        // Update state to display fallback UI on error
        return { hasError: true, errorMessage: String(error) };
    }

    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false,
            errorMessage: "",
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Logger.error("Error in ErrorBoundary component:");
        Logger.error(error);
        Logger.error(errorInfo);
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return (
                <div className="panel error buffer center clearance-large top-clearance-xlarge">
                    <h3 className="error wrappable">
                        Sorry, something went wrong loading the {this.props.sectionName ?? "page"}.
                    </h3>
                    <p className="wrappable">{this.state.errorMessage}</p>
                </div>
            );
        } else {
            return this.props.children;
        }
    }
}
